<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between bg-black">
    <a class="nav-item fw-bold brand p-1" [routerLink]="['/']" routerLinkActive="router-link-active">
      <img class="home-logo" src="assets/images/Logos/Redbullslogo.svg" draggable="false" />
    </a>

    <div class="d-flex">
      <div
        class="glass-bg gloss-black wallet-page d-flex align-items-center justify-content-center ms-3 me-4"
        [routerLink]="['/rewards/wallet']"
      >
        <span class="material-symbols-outlined text-white">qr_code </span>
      </div>

      <button class="nav-item fw-bold navbar-toggler m-0 px-2" aria-label="Menu" (click)="isCollapsed = !isCollapsed">
        <div class="icon material-symbols-outlined">menu</div>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown text-white">
    <div class="d-flex flex-column">
      <!-- Close Button -->
      <button class="close-button position-absolute border-0" aria-label="Close Modal" (click)="isCollapsed = !isCollapsed">
        <span class="icon material-symbols-outlined cancel-icon">close</span>
      </button>

      <!-- Club Logo -->
      <div class="d-flex align-items-center justify-content-start menu-logo-div">
        <img src="assets/images/Logos/Redbullslogo.svg" class="menu-logo" [routerLink]="'/'" />
      </div>
      <div class="my-2" *ngIf="memberDetails$">
        <div *ngIf="memberCard$ | async as memberCard">
          <fgb-member-card-details [memberCard]="memberCard"></fgb-member-card-details>
        </div>
      </div>

      <div class="mobile-nav-button-container">
        <a
          class="nav-item px-0"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.account' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a
          class="nav-item px-0"
          [routerLink]="['/rewards/wallet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.wallet' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a
          class="nav-item px-0"
          [routerLink]="['/rewards']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.rewards' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a
          class="nav-item px-0"
          [routerLink]="['/challenges']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.challenges' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a
          class="nav-item px-0"
          [routerLink]="['/games']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.games' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.nav.ecash'">
          <a
            class="nav-item px-0"
            [routerLink]="['/ecash']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="left-side">
              <div class="nav-text">{{ 'nav.bulls.pay' | translate }}</div>
            </div>
            <div class="right-side">
              <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
            </div>
          </a>
        </ng-container>

        <a
          class="nav-item px-0"
          [routerLink]="['/earn']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.earn' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a class="nav-item px-0" href="{{ ticketTradeLink }}" target="_blank">
          <div class="left-side">
            <div class="nav-text">{{ 'nav.ticket.trade' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a
          class="nav-item px-0"
          [routerLink]="['/contact-us']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a
          class="nav-item px-0"
          [routerLink]="['/terms']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.terms' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a
          class="nav-item px-0"
          [routerLink]="['/faqs']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.faq' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a
          class="nav-item px-0"
          [routerLink]="['/sweepstakeofficialrules']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="left-side">
            <div class="nav-text">{{ 'nav.official.rules' | translate }}</div>
          </div>
          <div class="right-side">
            <div class="material-symbols-outlined icon">keyboard_arrow_right</div>
          </div>
        </a>

        <a class="nav-item px-0 text-white mb-5" (click)="logout()">
          <div class="left-side">
            <div class="nav-text">{{ 'nav.log.out' | translate }}</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
